<div class="wrapper">
  <app-header></app-header>
  <app-side-nav></app-side-nav>
  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
